import axios from 'axios'
import { attachAuthenticatedAxios } from '../modules/auth/core/authTokenService'
import { decryptResponse } from './decrypt'

const API_URL = process.env.REACT_APP_API_URL

export const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosClient.interceptors.response.use(async (res) => {
  if (res.data) {
    res.data = await decryptResponse(res.data)
  }
  return res
})

export const axiosClientAuth = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

attachAuthenticatedAxios(axiosClientAuth)
